import { useMemo } from "react";
import { PushTestFeatureConfig, useFeatureFlags } from "./useFeatureFlag";
import { useAppState } from "../../../stores/appContext";

export type FeatureFlagName = "signup";

export const useFeatureEnabled = (
    featureFlagName: FeatureFlagName
): boolean => {
    const featureFlags = useFeatureFlags();

    if (featureFlagName === "signup") {
        return featureFlags.signup;
    }

    return false;
};

export function isPushTestPageVisibleForUser(
    pushTest: PushTestFeatureConfig,
    cognitoUsername: string | undefined
): boolean {
    return (
        pushTest.enabled &&
        cognitoUsername !== undefined &&
        pushTest.allowedCognitoUsernames.includes(cognitoUsername)
    );
}

export function usePushTestPageVisible(): boolean {
    const config = useFeatureFlags();
    const { cognitoUsername } = useAppState();
    return useMemo(
        () => isPushTestPageVisibleForUser(config.pushTest, cognitoUsername),
        [config.pushTest, cognitoUsername]
    );
}
